export default __webpack_public_path__ + "static/media/dashboard_Product_zero.8864e509.svg";